import { render } from "./NewsArea.vue?vue&type=template&id=79b4c6de&scoped=true"
import script from "./NewsArea.vue?vue&type=script&lang=js"
export * from "./NewsArea.vue?vue&type=script&lang=js"

import "./NewsArea.vue?vue&type=style&index=0&id=79b4c6de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b4c6de"]])

export default __exports__